import React, { useState } from "react";
import { toast } from "react-toastify";
import { downloadCsv } from "../utils/exportCsv";

const ExportCsvButton = ({ filename, columns, fetchRows }) => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const rows = await fetchRows();
      if (!rows || rows.length === 0) {
        toast.info("No data to export.");
        return;
      }
      downloadCsv(filename, columns, rows);
    } catch (error) {
      console.error("CSV export failed:", error);
      toast.error("Failed to export CSV.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      className="btn btn-outline-secondary btn-sm"
      onClick={handleExport}
      disabled={loading}
    >
      {loading ? "Exporting..." : "Export CSV"}
    </button>
  );
};

export default ExportCsvButton;
